module.exports = ["The project, right now, is just the dream ","and creative exercise of some no-ones. ","It is only through you and your collaboration ","that we can make this project real."]


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/infoclosing.json
// module id = 622
// module chunks = 3